
export enum accessPointType{
    P01 = 'P01', P02 = 'P02', P03 = 'P03', P04 = 'P04', P05 = 'P05', P06 = 'P06', P07 = 'P07', P08 = 'P08', P09 = 'P09', P10 = 'P10', P11 = 'P11', P12 = 'P12', P13 = 'P13', P14 = 'P14', P15 = 'P15', P16 = 'P16', P17 = 'P17', P18 = 'P18', P19 = 'P19', P20 = 'P20', P21 = 'P21', P22 = 'P22', P23 = 'P23', P24 = 'P24', P25 = 'P25', P26 = 'P26'
}
export enum activity{
    A01 = 'A01', A02 = 'A02', A03 = 'A03', A04 = 'A04', A05 = 'A05', A06 = 'A06', A07 = 'A07', A08 = 'A08', A09 = 'A09', A10 = 'A10', A11 = 'A11', A12 = 'A12', A13 = 'A13', A14 = 'A14', A15 = 'A15', A16 = 'A16', A17 = 'A17', A18 = 'A18', A19 = 'A19', A20 = 'A20', A21 = 'A21', A22 = 'A22', A23 = 'A23', A24 = 'A24', A25 = 'A25'
}
export enum activityStatus{
    CREATED = 'CREATED',
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED'
}
export enum categoryName{
    B01 = 'B01', B02 = 'B02', B03 = 'B03', B04 = 'B04', B05 = 'B05', B06 = 'B06', B07 = 'B07'
}
export enum addressType{
    POSTAL = 'POSTAL',
    GEOLOC = 'GEOLOC',
    GEOGRAPHICAL = 'GEOGRAPHICAL',
    EMAIL = 'EMAIL',
    TELEPHONE = 'TELEPHONE',
    WEB = 'WEB',
    ELECTRONIC = 'ELECTRONIC',
    INTERNALLOCATION = 'INTERNALLOCATION'
}
export enum certificateType{
    ISO_9001_2015 = 'ISO-9001-2015',
    ISO_14001_2015 = 'ISO-14001-2015',
    ISO_45001 = 'ISO-45001',
    IATF_16949_2016 = 'IATF-16949-2016'
}
export enum attachmentType{
    INCOTERM = 'INCOTERM',
    FACTORY_CODE = 'FACTORY_CODE'
}
export enum physicalState{
    Greenfield = 'Greenfield',
    Brownfield = 'Brownfield',
    Built = 'Built',
    Destroyed = 'Destroyed'
}

export class site{
    "identifier": string
    "endDate": string
    "isMergingSite": true
    "irnAuthor": string
    "siteParentIdentifier": string
    "description": string
    "cityId": string
    "siteParentId": string
    "countryId": string
    "siteParentName": string
    "rowId": string
    "siaAuthor": string
    "physicalState": physicalState
    "cityName": string
    "activeStatus": activityStatus
    "countryCode": string
    "name": string
    "countryName": string
    "effectiveDate": string
}
export class sites{
    "sites":site[]
}

export class accessPointIdentifier{
    "identifier": string
    "siteIdentifier": string
    "endDate": string
    "sourceSystemId": string
    "identifierValue": string
    "accessPointIdentifier": string
    "rowId": string
    "accessPointType": accessPointType
    "identifierId": string
    "sourceSystemName": string
    "accessPointRowId": string
    "effectiveDate": string
    "identifierTypeName": string
}
export class accessPointIdentifiers{
    "access-point-identifiers": accessPointIdentifier[]
}

export class accessPoint{
    "identifier": string
    "siteIdentifier": string
    "activity": activity
    "endDate": string
    "irnAuthor": string
    "siteName": string
    "realEstateAssetId": string
    "label": string
    "type": accessPointType
    "rowId": string
    "siaAuthor": string
    "activeStatus": activityStatus
    "effectiveDate": string
}
export class accessPoints{
    "access-points": accessPoint[]
}

export class accessPointAddress{
    "addressSummary": string
    "accessPointType": accessPointType
    "addressType": addressType
    "accessPointId": string
    "accessPointIdentifier": string
    "addressIdentifier": string
    "rowId": string
    "addressId": string
}
export class  accessPointAddresses{
    "access-points-addresses": accessPointAddress[]
}

export class realEstateAssetAssignment{
    "legalEntityIdentifier": string
    "endDate": string
    "realEstateAssetName": string
    "realEstateAssetIdentifier": string
    "realEstateAssetId": string
    "categoryCode": string
    "categoryName": categoryName
    "rowId": string
    "desription": string
    "legalEntityId": string
    "effectiveDate": string
    "categoryId": string
    "legalEntityCorporateName": string
}
export class realEstateAssetAssignments{
    "real-estate-asset-assignments": realEstateAssetAssignment[]
}

export class realEstateAssetIdentifier{
    "identifier": string
    "endDate": string
    "businessIdentifierValue": string
    "sourceSystemId": string
    "realEstateAssetName": string
    "realEstateAssetIdentifier": string
    "realEstateAssetId": string
    "identifierType": string
    "rowId": string
    "businessIdentifierName": string
    "sourceSystemName": string
    "businessIdentifierId": string
    "effectiveDate": string
}
export class realEstateAssetIdentifiers{
    "real-estate-asset-identifiers": realEstateAssetIdentifier[]
}

export class legalEntity{
    "corporateName": string
    "identifier": string
    "active": true   
    "description": string
    "legalForm": string
    "rowId": string
}
export class legalEntities{
    "legal-entities": legalEntity[]
}

export class identifierType{
    "name": string
    "active": true 
    "description": string
    "rowId": string
}
export class identifierTypes{
    "identifier-types": identifierType[]
}

export class sourceSystem{
    "name": string
    "description": string
    "active": true 
    "rowId": string
}
export class sourceSystems{
    "source-systems": sourceSystem[]
}

export class siteCertification{
    "identifier": string
    "number": string
    "siteIdentifier": string
    "realEstateAssetId": string
    "siteName": string
    "type": certificateType
    "expirationDate": string
    "rowId": string
    "startValidationDate": string
}
export class siteCertifications{
    "sites-certifications":siteCertification[]
}

export class accessPointAttachment{
    "acp1Identifier": string
    "acp1Id": string
    "acp2Id": string
    "acp2ReaId": string
    "endDate": string
    "acp1Type": accessPointType
    "acp1ReaId": string
    "acp2Type": accessPointType
    "type": "RAFT_EXCEPTION"
    "effectiveDate": string
    "acp2Identifier": string
    "rowId": string
}
export class accessPointAttachments{
    "access-point-attachments": accessPointAttachment[]
}

export class accessPointAttachmentAttribute{
    "attId": string
    "identifier": string
    "acp1Id": string
    "acp2Id": string
    "type": attachmentType
    "value": string
    "rowId": string
}
export class accessPointAttachmentAttributes{
    "access-point-attachment-attributes":accessPointAttachmentAttribute[]
}